import { DictionaryItem } from '@/Types/api/Dictionaries';

import { ListItemModel } from '../model/ListItemModel';

export const mapListItemModelToDictionaryItem = (item: ListItemModel): DictionaryItem => {
    return {
        id: item.entityId,
        name: item.title,
    };
};
